import React from 'react';
import {
  StyleSheet, Document, Page, View, Text
} from '@react-pdf/renderer';
import { toBrazilDateTime } from '../../../components/mask';

interface Row {
  Nome: string;
  Email: string;
  Telefone: string;
  'Data Cadastro': string;
  Franquia: string;
}

interface OwnProps {
  data: Row[];
  fileName: string;
}

export default function CustomersPrint({ data, fileName }: OwnProps) {
  const styles = StyleSheet.create({
    body: {
      padding: 10,
      paddingBottom: 60
    },
    table: {
      width: 'auto',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row'
    },
    // Larguras fixas para as colunas
    colHeader: {
      width: '20%',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderBottomColor: '#000',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    col: {
      width: '20%',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    // Colunas maiores para campos de texto longo
    colLargeHeader: {
      width: '25%',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderBottomColor: '#000',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    colLarge: {
      width: '25%',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    tableCellHeader: {
      margin: 'auto',
      fontSize: 10,
      fontWeight: 500,
      textAlign: 'center'
    },
    tableCell: {
      fontSize: 8,
      padding: 2
    },
    header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: 'center',
      color: 'grey'
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 10,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey'
    }
  });

  const firstRow = data[0] || {};
  const rowKeys = Object.keys(firstRow);

  // Função para determinar a largura da coluna baseada no conteúdo
  const getColumnStyle = (key: string, colIndex: number) => {
    // Campos que precisam de mais espaço
    const largeColumns = ['Nome', 'Email'];
    if (largeColumns.includes(key)) {
      return colIndex === 0 ? styles.colLargeHeader : styles.colLarge;
    }
    return colIndex === 0 ? styles.colHeader : styles.col;
  };

  return (
    <Document>
      <Page size="A4" style={styles.body}>
        <Text style={styles.header} fixed>
          Relatório de Clientes
          {'\n'}
          {fileName}
          {'\n'}
          {toBrazilDateTime(new Date())}
        </Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            {rowKeys.map((key) => (
              <View style={getColumnStyle(key, 0)} key={`header-${key}`}>
                <Text style={styles.tableCellHeader}>{key}</Text>
              </View>
            ))}
          </View>
          {data.map((row) => (
            <View style={styles.tableRow} key={`row-${row.Nome}-${row.Email}`} wrap>
              {Object.entries(row).map(([key, value]) => (
                <View style={getColumnStyle(key, 1)} key={`cell-${row.Nome}-${key}`}>
                  <Text style={styles.tableCell}>{String(value)}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}`
          )}
          fixed
        />
      </Page>
    </Document>
  );
}
